import notifications from './notifications-reducer';

export * from './notifications-reducer';
export default notifications;
